export const convertTo24HourFormat = (timeString: string) => {
  // Create a Date object from the input string
  const timeParts = timeString.split(':').map((part) => parseInt(part, 10))
  const last2Character = timeString.slice(-2)

  if (last2Character === 'PM' && timeParts[0] < 12) {
    timeParts[0] += 12
  }

  const date = new Date(2024, 5, 11) // Month is 0-indexed, 5 = June
  date.setHours(timeParts[0], timeParts[1], timeParts[2])

  // Get hours in 24-hour format (0-23)
  const hours = date.getHours()

  // Get minutes
  const minutes = date.getMinutes().toString().padStart(2, '0')

  // Return the formatted time string
  return `${hours}:${minutes}`
}
